import './notfound.scss';
import { BrandButton } from '../components/form/buttons';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
    const navigate = useNavigate();
    return (
        <div className='notFoundPage'>
            <h1>404 Not Found</h1>
            <p>Sorry looks, like the page you're looking for cannot be found.</p>
            <div className='btnHolder'>
            <BrandButton onClick={() => navigate('/', { replace: true }) }>GO HOME</BrandButton>
            </div>
            
        </div>
    )
}

export default NotFound;